/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import InPageLeadForm from '@nmx/template/dist/componentLibrary/modules/InPageLeadForm';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import FinancialPlanningSection from './components/financialPlanningSection';
import HeroSection from './components/heroSection';
import InPageLeadFormLazyLoadContainer from '../../components/inPageLeadFormLazyLoadContainer';
import IntroSection from './components/introSection';
// images
import highResDesktopImageWebp from './components/heroSection/images/special-needs-planning-hero-desktop.webp';
import highResMobileImageWebp from './components/heroSection/images/special-needs-planning-hero-mobile.webp';
// other utils
import { getImmediateMatchFeatureFlag } from '../../../utils/getFeatureFlags/getFeatureFlags';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();
  // We don't want to load recaptcha on page load (for performance reasons) so we will load it once the in page lead for is engaged with
  const [loadRecaptcha, setLoadRecaptcha] = useState(false);
  const [immediateMatchFeatureFlag, setImmediateMatchFeatureFlag] = useState(false);

  useEffect(() => {
    getImmediateMatchFeatureFlag(setImmediateMatchFeatureFlag, config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Financial Planning',
          linkUrl: '/financial-planning/',
          linkAriaLabel: 'Northwestern Mutual Financial Planning',
        },
        {
          pageName: 'Special Needs Planning',
          linkUrl: '/special-needs-planning/',
          linkAriaLabel: 'Northwestern Mutual Special Needs Planning',
        },
      ]}
      dynamicConfig={dynamicConfig}
      useReCaptcha={loadRecaptcha}
      disclaimerFootnotes={[
        <>
          <sup>1</sup>Depending on your location and circumstances, we may match you with a non&#45;ChSNC&#174; certified advisor or contact you to determine whether an advisor is right for your situation and may direct you to other resources.
        </>,
      ]}
      disableDisclaimerTopBorder>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImageWebp} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImageWebp} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <HeroSection />

      <IntroSection />

      <FinancialPlanningSection />

      <InPageLeadFormLazyLoadContainer>
        <InPageLeadForm
          sectionId='in-page-lead' // note: id in-page-lead-form will be on the Form element itself.
          config={config}
          formLocation='special-needs-planning'
          immediateMatchFeatureFlagEnabled={immediateMatchFeatureFlag}
          onFormEngaged={() => {
            if (!loadRecaptcha) {
              setLoadRecaptcha(true);
            }
          }}
          variant='embedded'
          specialization='SPECIAL_NEEDS'
        />
      </InPageLeadFormLazyLoadContainer>

      <ContentHub
        sectionId='content-hub'
        headingText='More on special needs planning'
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
      />
    </Page>
  );
};
